/**
 * User Repository Hook
 *
 * Provides access to the user repository from the context.
 */

import { useRepositoryContext } from '../repositories';
import type { IUserRepository } from '../repositories/interfaces/IUserRepository';

/**
 * Hook to access the user repository
 * Must be used within a RepositoryProvider
 */
export function useUserRepository(): IUserRepository {
  const { users } = useRepositoryContext();
  return users;
}
